// libs
import React, { memo } from 'react';
import { PRODUCT_INTERACTION } from 'shared/helpers/analytics/constants';
import NFAnalytics from 'shared/helpers/analytics/NFAnalytics';

// components
import CAVProduct from 'shared/layouts/DetailsPage/components/Widgets/components/CAVProduct';

// styles
import { CAVDesktopWrapper } from './styles';

interface ICAVDesktopProps {
  products: Listing.IProduct[];
  widgetMetaData: Record<string, any>;
}

function RenderDesktopCAV({ products, widgetMetaData }: ICAVDesktopProps) {
  const onProductInteraction = () => {
    NFAnalytics.updateDatalayerBeforeNext({
      productInteractedType: PRODUCT_INTERACTION.RECO_WIDGET,
      widgetTitle: widgetMetaData?.title,
      widgetType: widgetMetaData?.widgetType,
    });
  };
  return (
    <CAVDesktopWrapper>
      {products.map((item, index) => {
        return (
          <CAVProduct item={item} key={`${index}-${item.id}`} onClick={onProductInteraction} />
        );
      })}
    </CAVDesktopWrapper>
  );
}

export default memo(RenderDesktopCAV);
